export default __webpack_public_path__ + "static/media/HiddenMouseketeer.b5ca0f1d.png";